export default "__VITE_ASSET__ySezOZha__"